export default __webpack_public_path__ + "static/media/7.522ab933.png";